import { render, staticRenderFns } from "./PDLImportYgd.vue?vue&type=template&id=e331e8ac&scoped=true&"
import script from "./PDLImportYgd.vue?vue&type=script&lang=js&"
export * from "./PDLImportYgd.vue?vue&type=script&lang=js&"
import style0 from "./PDLImportYgd.vue?vue&type=style&index=0&id=e331e8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e331e8ac",
  null
  
)

export default component.exports